import { render } from "./HomeworkForm.vue?vue&type=template&id=7729ad88"
import script from "./HomeworkForm.vue?vue&type=script&lang=js"
export * from "./HomeworkForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__